import {
  StarIcon,
  PinIcon,
  MonitorIcon,
  MegaphoneIcon,
  SparkIcon,
  GoogleIcon,
  BriefcaseIcon,
  MapIcon,
  PhoneBookIcon,
  DotsIcon,
  StackIcon,
  HelpIcon,
  CalendarIcon,
  ClockIcon,
  TimerIcon,
  WebsiteIcon,
   RefreshIcon
} from "./icons";

export const SERVICES = [
  { key: "bewertungen", label: "Bewertungen", icon: StarIcon },
  { key: "local-listing", label: "Local-Listing", icon: PinIcon },
  { key: "webdesign", label: "Webdesign", icon: MonitorIcon },
  { key: "smm", label: "Social Media Marketing", icon: MegaphoneIcon },
  { key: "ki", label: "KI-Automatisierung", icon: SparkIcon },
];

/**
 * Each service has its own steps (different number allowed).
 * Step types supported in this starter:
 * - options (cards)
 * - appointment (date/time/duration)
 * - contact (form)
 */
export const SERVICE_FLOWS = {
  bewertungen: {
    steps: [
      {
        id: "platform",
        title: "Plattform",
        subtitle: "Auf welcher Plattform benötigen Sie Löschungen?",
        type: "options",
        field: "platform",
        options: [
          { key: "google", label: "Google", icon: GoogleIcon, subtitle: "Plattform auswählen" },
          { key: "kununu", label: "Kununu", icon: BriefcaseIcon, subtitle: "Plattform auswählen" },
          { key: "golocal", label: "GoLocal", icon: MapIcon, subtitle: "Plattform auswählen" },
          { key: "1180", label: "1180", icon: PhoneBookIcon, subtitle: "Plattform auswählen" },
          { key: "andere", label: "Andere", icon: DotsIcon, subtitle: "Plattform auswählen" },
        ],
      },
      {
        id: "qty",
        title: "Anzahl",
        subtitle: "Wie viele Löschungen wünschen Sie?",
        type: "options",
        field: "qty",
        options: [
          { key: "1-5", label: "1–5", icon: StackIcon, subtitle: "Anzahl" },
          { key: "6-10", label: "6–10", icon: StackIcon, subtitle: "Anzahl" },
          { key: "10plus", label: "Mehr als 10", icon: StackIcon, subtitle: "Anzahl" },
          { key: "unknown", label: "Unbekannt", icon: HelpIcon, subtitle: "Anzahl" },
        ],
      },
      {
        id: "contact",
        title: "Kontakt",
        subtitle: "Angebot per E-Mail",
        type: "contact",
      },
    ],
  },

  "local-listing": {
    steps: [
      {
        id: "appointment",
        title: "Termin",
        subtitle: "Wählen Sie Datum, Uhrzeit & Dauer",
        type: "appointment",
        fields: {
          date: "appointmentDate",
          time: "appointmentTime",
          duration: "appointmentDuration",
        },
        // quick options (you can edit anytime)
        durationOptions: [
          { key: "15", label: "15 Min", icon: TimerIcon },
          { key: "30", label: "30 Min", icon: TimerIcon },
          { key: "45", label: "45 Min", icon: TimerIcon },
          { key: "60", label: "60 Min", icon: TimerIcon },
        ],
        icons: { date: CalendarIcon, time: ClockIcon },
      },
      {
        id: "contact",
        title: "Kontakt",
        subtitle: "Bestätigung & Angebot per E-Mail",
        type: "contact",
      },
    ],
  },

  // Starter flows (you can replace steps later)
 webdesign: {
  steps: [
    // Step 1: website type (single select)
    {
      id: "webdesignType",
      title: "Webdesign",
      subtitle: "Was benötigen Sie?",
      type: "options",
      field: "webdesignType",
      options: [
        { key: "new", label: "Neue Website", icon: WebsiteIcon, subtitle: "Projekt starten" },
        { key: "redesign", label: "Redesign", icon: RefreshIcon, subtitle: "Bestehende Website verbessern" },
      ],
    },

    // Step 2: features (multi select)
    {
      id: "features",
      title: "Funktionen",
      subtitle: "Welche Funktionen benötigen Sie?",
      type: "multiOptions",
      field: "webdesignFeatures", // will store array in answers.webdesignFeatures = [...]
      options: [
        { key: "kontaktformular", label: "Kontaktformular" },
        { key: "blog-news", label: "Blog-News" },
        { key: "terminbuchung", label: "Terminbuchung" },
        { key: "funnel", label: "Funnel" },
        { key: "mehrsprachigkeit", label: "Mehrsprachigkeit" },
        { key: "sonstiges", label: "Sonstiges" },
      ],
      minSelected: 0, // allow none if you want
    },

    // Step 3: budget (single select)
    {
      id: "budget",
      title: "Budget",
      subtitle: "Welches Budget planen Sie?",
      type: "options",
      field: "webdesignBudget",
      options: [
        { key: "<2000", label: "Unter €2.000", subtitle: "Budget auswählen" },
        { key: "2000-5000", label: "€2.000 – €5.000", subtitle: "Budget auswählen" },
        { key: "5000-10000", label: "€5.000 – €10.000", subtitle: "Budget auswählen" },
        { key: ">10000", label: "Über €10.000", subtitle: "Budget auswählen" },
      ],
    },

    // Final: contact form
    {
      id: "contact",
      title: "Kontakt",
      subtitle: "Angebot per E-Mail",
      type: "contact",
    },
  ],
},


  smm: {
    steps: [
      {
        id: "contact",
        title: "Kontakt",
        subtitle: "Angebot per E-Mail",
        type: "contact",
      },
    ],
  },

  ki: {
    steps: [
      {
        id: "contact",
        title: "Kontakt",
        subtitle: "Angebot per E-Mail",
        type: "contact",
      },
    ],
  },
};

export function getServiceLabel(serviceKey) {
  return SERVICES.find((s) => s.key === serviceKey)?.label || "";
}

export function getServiceIcon(serviceKey) {
  return SERVICES.find((s) => s.key === serviceKey)?.icon || null;
}
